import { render } from "./TheAlarm.vue?vue&type=template&id=39dabf32"
import script from "./TheAlarm.vue?vue&type=script&lang=js"
export * from "./TheAlarm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__